<template>
	<vx-card class="ticket-payment-info">
		<SetStageFailedPopup
			:active.sync="failedPopupActive"
			@confirm="setStageFailed"
		/>
		<SetStageDonePopup
			:active.sync="donePopupActive"
			:selectedStage="selectedStage"
			@confirm="setStageDone"
		/>
		<SetAddNewAmountAuthorPopup
			:active.sync="addNewAmountAuthorPopupActive"
			:selectedStage="selectedStage"
			@confirm="setAddNewAmountAuthor"
		/>
		<SetStageDoneAfterPatchModePopup
			:active.sync="doneAfterPatchModePopupActive"
			@confirm="setStageDoneAfterPatchMode"
		/>
		<SetStagePatchModePopup
			:active.sync="patchModePopupActive"
			@confirm="setStagePatchMode"
		/>

		<b>{{ $t('paymentDetails') }}</b>
		<div class="stages">
			<div
				 v-for="(stage,index) in stages"
				 :key="index"
				 class="stage"
			>
				<div class="head">
					<span class="stage__title">{{ $t('stage') }} {{ index+1 }}</span>

					<span
						v-if="index !== 0 && (!isReadOnly || boolCanEditWithoutNotice)"
						@click="removeStage(stage.id)"
						class="cursor-pointer"
					>
						<svg width="25" height="25" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;"><defs></defs><rect x="0" y="0" width="25" height="25" fill="transparent" class="stencil__selection-helper"></rect><path d="M9.093319194061507 9.90038872691934C9.093319194061507 9.90038872691934 9.093319194061507 19.26627793974733 9.093319194061507 19.26627793974733 9.093319194061506 19.420149011985746 9.040296924708379 19.545675413022348 8.934252386002122 19.642857142857142 8.828207847295864 19.740038872691926 8.69123365146695 19.788629737609327 8.523329798515377 19.78862973760933 8.523329798515377 19.78862973760933 7.383351007423118 19.78862973760933 7.383351007423118 19.78862973760933 7.215447154471545 19.78862973760933 7.07847295864263 19.740038872691937 6.9724284199363735 19.642857142857142 6.866383881230116 19.545675413022348 6.813361611876989 19.420149011985746 6.813361611876989 19.26627793974733 6.813361611876989 19.26627793974733 6.813361611876989 9.90038872691934 6.813361611876989 9.90038872691934 6.813361611876989 9.74651765468092 6.866383881230116 9.620991253644315 6.9724284199363735 9.523809523809526 7.07847295864263 9.426627793974735 7.215447154471545 9.378036929057338 7.383351007423118 9.378036929057338 7.383351007423118 9.378036929057338 8.523329798515377 9.378036929057338 8.523329798515377 9.378036929057338 8.69123365146695 9.378036929057338 8.828207847295864 9.426627793974733 8.934252386002122 9.523809523809526 9.040296924708379 9.620991253644318 9.093319194061506 9.746517654680922 9.093319194061507 9.90038872691934 9.093319194061507 9.90038872691934 9.093319194061507 9.90038872691934 9.093319194061507 9.90038872691934M13.639978791092258 9.90038872691934C13.639978791092258 9.90038872691934 13.639978791092258 19.26627793974733 13.639978791092258 19.26627793974733 13.639978791092258 19.420149011985746 13.58695652173913 19.545675413022348 13.480911983032875 19.642857142857142 13.374867444326618 19.740038872691926 13.237893248497702 19.788629737609327 13.069989395546129 19.78862973760933 13.069989395546129 19.78862973760933 11.930010604453871 19.78862973760933 11.930010604453871 19.78862973760933 11.762106751502298 19.78862973760933 11.625132555673384 19.740038872691937 11.519088016967126 19.642857142857142 11.41304347826087 19.545675413022348 11.36002120890774 19.420149011985746 11.360021208907742 19.26627793974733 11.360021208907742 19.26627793974733 11.360021208907742 9.90038872691934 11.360021208907742 9.90038872691934 11.360021208907742 9.74651765468092 11.41304347826087 9.620991253644315 11.519088016967126 9.523809523809526 11.625132555673384 9.426627793974735 11.762106751502296 9.378036929057338 11.930010604453871 9.378036929057338 11.930010604453871 9.378036929057338 13.069989395546129 9.378036929057338 13.069989395546129 9.378036929057338 13.229056203605513 9.378036929057338 13.366030399434429 9.426627793974733 13.480911983032875 9.523809523809526 13.59579356663132 9.620991253644318 13.648815835984449 9.746517654680922 13.639978791092258 9.90038872691934 13.639978791092258 9.90038872691934 13.639978791092258 9.90038872691934 13.639978791092258 9.90038872691934M18.17338282078473 9.90038872691934C18.17338282078473 9.90038872691934 18.17338282078473 19.26627793974733 18.17338282078473 19.26627793974733 18.17338282078473 19.420149011985746 18.120360551431602 19.545675413022348 18.014316012725345 19.642857142857142 17.908271474019088 19.740038872691926 17.775715800636267 19.788629737609327 17.61664899257688 19.78862973760933 17.61664899257688 19.78862973760933 16.476670201484623 19.78862973760933 16.476670201484623 19.78862973760933 16.30876634853305 19.78862973760933 16.171792152704136 19.740038872691937 16.06574761399788 19.642857142857142 15.95970307529162 19.545675413022348 15.906680805938493 19.420149011985746 15.906680805938496 19.26627793974733 15.906680805938496 19.26627793974733 15.906680805938496 9.90038872691934 15.906680805938496 9.90038872691934 15.906680805938496 9.74651765468092 15.959703075291623 9.620991253644315 16.06574761399788 9.523809523809526 16.171792152704132 9.426627793974735 16.308766348533048 9.378036929057338 16.476670201484623 9.378036929057338 16.476670201484623 9.378036929057338 17.61664899257688 9.378036929057338 17.61664899257688 9.378036929057338 17.77571580063627 9.378036929057338 17.908271474019088 9.426627793974733 18.014316012725345 9.523809523809526 18.1203605514316 9.620991253644318 18.17338282078473 9.746517654680922 18.17338282078473 9.90038872691934 18.17338282078473 9.90038872691934 18.17338282078473 9.90038872691934 18.17338282078473 9.90038872691934M20.453340402969246 21.67152575315841C20.453340402969246 21.67152575315841 20.453340402969246 6.256073858114675 20.453340402969246 6.256073858114675 20.453340402969246 6.256073858114675 4.546659597030754 6.256073858114675 4.546659597030754 6.256073858114675 4.546659597030754 6.256073858114675 4.546659597030754 21.67152575315841 4.546659597030754 21.67152575315841 4.546659597030753 21.914480077745385 4.586426299045599 22.13718820861678 4.665959703075292 22.339650145772598 4.745493107104984 22.54211208292841 4.833863556026865 22.687884677680596 4.931071049840933 22.77696793002916 5.028278543655003 22.866051182377714 5.090137857900319 22.910592808551993 5.1166489925768825 22.910592808551993 5.1166489925768825 22.910592808551993 19.88335100742312 22.910592808551993 19.88335100742312 22.910592808551993 19.91869918699187 22.910592808551993 19.980558501237187 22.866051182377714 20.06892895015907 22.77696793002916 20.157299399080948 22.687884677680596 20.241251325556735 22.54211208292841 20.32078472958643 22.339650145772598 20.400318133616118 22.13718820861678 20.444503358077057 21.914480077745385 20.453340402969246 21.67152575315841 20.453340402969246 21.67152575315841 20.453340402969246 21.67152575315841 20.453340402969246 21.67152575315841M8.523329798515377 4.166666666666666C8.523329798515377 4.166666666666666 16.476670201484623 4.166666666666666 16.476670201484623 4.166666666666666 16.476670201484623 4.166666666666666 15.628313891834571 2.271622934888241 15.628313891834571 2.271622934888241 15.53994344291269 2.17444120505345 15.438317426652528 2.1137026239067063 15.323435843054085 2.0894071914480077 15.323435843054085 2.0894071914480077 9.689819724284199 2.0894071914480077 9.689819724284199 2.0894071914480077 9.574938140685754 2.1137026239067063 9.473312124425593 2.17444120505345 9.384941675503713 2.271622934888241 9.384941675503713 2.271622934888241 8.523329798515377 4.166666666666666 8.523329798515377 4.166666666666666M25 4.689018464528669C25 4.689018464528669 25 5.733722060252672 25 5.733722060252672 25 5.887593132491093 24.946977730646875 6.013119533527698 24.840933191940614 6.110301263362489 24.734888653234357 6.20748299319728 24.597914457405444 6.256073858114675 24.430010604453873 6.256073858114675 24.430010604453873 6.256073858114675 22.720042417815485 6.256073858114675 22.720042417815485 6.256073858114675 22.720042417815485 6.256073858114675 22.720042417815485 21.67152575315841 22.720042417815485 21.67152575315841 22.720042417815485 22.57855523161646 22.44167550371156 23.360058309037903 21.884941675503715 24.016034985422742 21.32820784729587 24.67201166180758 20.66101095793567 25 19.88335100742312 25 19.88335100742312 25 5.1166489925768825 25 5.1166489925768825 25 4.330151997172146 25 3.658536585365854 24.68011013929381 3.1018027571580062 24.04033041788144 2.5450689289501587 23.400550696469065 2.266702014846235 22.635244574020085 2.2667020148462353 21.7444120505345 2.2667020148462353 21.7444120505345 2.2667020148462353 6.256073858114675 2.2667020148462353 6.256073858114675 2.2667020148462353 6.256073858114675 0.5699893955461294 6.256073858114675 0.5699893955461294 6.256073858114675 0.40208554259455637 6.256073858114675 0.2651113467656415 6.20748299319728 0.15906680805938495 6.110301263362489 0.05302226935312831 6.013119533527698 0 5.887593132491093 0 5.733722060252672 0 5.733722060252672 0 4.689018464528669 0 4.689018464528669 0 4.53514739229025 0.05302226935312831 4.409620991253645 0.15906680805938495 4.312439261418854 0.2651113467656415 4.2152575315840615 0.40208554259455637 4.166666666666666 0.5699893955461294 4.166666666666666 0.5699893955461294 4.166666666666666 6.057794273594911 4.166666666666666 6.057794273594911 4.166666666666666 6.057794273594911 4.166666666666666 7.290562036055143 1.4577259475218662 7.290562036055143 1.4577259475218662 7.4761399787910925 1.0528020732102363 7.798692117355956 0.7086167800453516 8.258218451749736 0.425170068027211 8.717744786143514 0.14172335600907005 9.18610816542948 0 9.663308589607636 0 9.663308589607636 0 15.336691410392365 0 15.336691410392365 0 15.813891834570521 0 16.282255213856484 0.14172335600907005 16.741781548250266 0.425170068027211 17.201307882644045 0.7086167800453516 17.519441498762816 1.0528020732102363 17.696182396606577 1.4577259475218662 17.696182396606577 1.4577259475218662 18.94220572640509 4.166666666666666 18.94220572640509 4.166666666666666 18.94220572640509 4.166666666666666 24.430010604453873 4.166666666666666 24.430010604453873 4.166666666666666 24.597914457405444 4.166666666666666 24.73488865323436 4.2152575315840615 24.840933191940614 4.312439261418854 24.946977730646868 4.409620991253645 24.999999999999996 4.53514739229025 25 4.689018464528669 25 4.689018464528669 25 4.689018464528669 25 4.689018464528669" stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(234, 84, 85)" fill-rule="evenOdd"></path></svg>
					</span>

					<div v-if="isReadOnly" class="vx-row">
						<div v-if="canManageStage(stage)" class="vx-col">
							<vs-button
								@click="patchModePopupActive = true"
								class="stage__control"
								color="warning"
							>{{ $t('modify') }}</vs-button>
						</div>

						<div v-if="canManageStage(stage)" class="vx-col">
							<vs-button
								@click="failedPopupActive = true"
								class="stage__control"
								color="danger"
							>{{ $t('notDone') }}</vs-button>
						</div>

						<div v-if="canManageStage(stage)" class="vx-col">
							<vs-button
								@click="selectedStage = stage; donePopupActive = true"
								class="stage__control"
								color="success"
							>{{ $t('done') }}</vs-button>
						</div>

						<div v-if="isReadOnly && canShowStageStatus(stage)" class="vx-col">
							<span
								:class="`${$getStatusColor(stage.status)} status`"
							>{{ $getStatus(stage.status) }}</span>
						</div>
					</div>
				</div>
				<div class="vx-row stage-list">
					<div class="vx-col w-full stage-list__item">
						<div
							class="vs-component vs-con-input-label vs-input vs-input-primary"
						>
							<label class="vs-input--label">{{ $t('workType') }}</label>
							<v-select
								v-model="stage.work_type_id"
								v-validate="'required'"
								:clearable="false"
								:reduce="work => work.id"
								:options="works"
								:dir="$vs.rtl ? 'rtl' : 'ltr'"
								:disabled="isReadOnly && !boolCanEditWithoutNotice"
								@input="changeStage(stage)"
								name="work"
								label="name"
								class="single-row-select"
							/>
						</div>
					</div>
					
					<div class="vx-col sm:w-1/2 w-1/2 stage-list__item">
						<vs-input
							:disabled="isReadOnly && !boolCanEditWithoutNotice"
							:label="$t('priceForClient')"
							v-model="stage.price_client"
							@input="changeStage(stage)"
						/>
					</div>

					<div class="vx-col sm:w-1/2 w-1/2 stage-list__item">
						<vs-input
							:disabled="isReadOnly && !boolCanEditWithoutNotice"
							:label="$t('pagesAmountShort')"
							v-model="stage.pages_number"
							@input="changeStage(stage)"
						/>
					</div>

					<div class="vx-col sm:w-1/2 w-1/2 stage-list__item">
						<div
							class="vs-component vs-con-input-label vs-input vs-input-primary"
						>
							<label class="vs-input--label">{{ $t('dueDate') }}</label>
							<div class="vs-con-input"></div>
							<vs-datepicker
								:disabled="isReadOnly && !boolCanEditWithoutNotice"
								:to="minDate"
								v-model="stage.due_date"
								@change="changeStage(stage)"
								format="dd.MM.yyyy"
								type="date"
							/>
						</div>
					</div>

					<div class="vx-col sm:w-1/2 w-1/2 stage-list__item">
						<div
							class="vs-component vs-con-input-label vs-input vs-input-primary"
						>
							<label class="vs-input--label">{{ $t('dueTimeAuthor') }}</label>
							<div class="vs-con-input"></div>
							<vs-datepicker
							:disabled="isReadOnly && !boolCanEditWithoutNotice"
								:to="minDate"
								v-model="stage.dueTimeAuthor"
								@change="changeStage(stage)"
								format="dd.MM.yyyy"
								type="datetime"
							>
							</vs-datepicker>
						</div>
					</div>
				</div>
				<div class="vx-row"
					v-if="['admin', 'manager', 'supervisor'].includes($store.state.auth.role) && stage.status != 'new'"
				>
					<hr class="w-full mt-2">
					<table v-if="stage.allAmountAuthor.length > 0"
						class="w-full ml-4">
						<tbody>
							<tr class="w-full"
								v-for="(item, index) in stage.allAmountAuthor"
							>
								<td class="flex-auto w-3/12"><b>{{ $t('amountForAuthor') }}</b></td>
								<td class="flex-auto w-4/12 text-right">
									{{ item.date_event}}
								</td>
								<td class="flex-auto w-2/12 text-right">
									{{ item.amount_author}} &euro;
								</td>
								<td class="flex-auto w-3/12 text-right">
									{{ item.author}}
								</td>
							</tr>
						</tbody>
					</table>
					<vs-button
						v-if="['admin', 'manager'].includes($store.state.auth.role) && stage.status != 'new'"
						@click="selectedStage = stage; addNewAmountAuthorPopupActive = true"
						class="stage__control m-4"
						color="warning"
					>{{ $t('addNewamountForAuthor') }}</vs-button>
					<hr class="w-full mb-2">
				</div>
				<div class="vx-row">
					<div v-if="stage.invoices && stage.invoices.length !== 0" class="vx-col">
						<div class="vx-row">
							<div
								v-for="(item, index) in stage.invoices"
								:key="index"
								class="vx-col"
							>
								<a target="_blank" 
									:class="{'frsNotConfirmPayment':stage.confirmPayment===0}" 
									:href="item.fullUrl || item.url" class="stage__invoice"
								>
									<img :src="item.fullUrl || item.url">
								</a>
							</div>
							<div
								v-if="stage.confirmPayment === 0 && ['admin'].indexOf($store.state.auth.role) !== -1"
								class="vx-col flex flex-col w-full mt-6"
							>
								<div class="flex">
									<span
										class="status status-ok cursor-pointer"
										@click="confirmPaymentModalActive = true"
									>{{ $t('confirmPayment') }}</span>
								</div>
								<ConfirmPaymentModal
									v-if="stage.confirmPayment === 0"
									:active.sync="confirmPaymentModalActive"
									:priceClient="stage.price_client"
									@accept="confirmStagePaymentInBank(stage)"
								/>
							</div>
						</div>
					</div>
					<div
						v-if="canShowUpload(stage)"
						class="vx-col flex flex-col w-full mt-6"
					>
						<vs-upload
							v-if="isReadOnly"
							:show-upload-button="false"
							accept=".jpg,.jpeg,.png"
							:text="$t('loadPhoto')"
							@change="addPaymentPhotos"
							@on-delete="deletePaymentPhoto"
						/>

						<div class="flex">
							<span
								v-if="paymentPhotos.length !== 0"
								class="status status-ok cursor-pointer"
								@click="confirmStagePayment(stage.id)"
							>{{ $t('downloadChecks') }}</span>
						</div>
					</div>
				</div>
				<div v-if="stage.status === 'patch_mode'">
					<hr class="mt-4 mb-2 w-full">

					<b>{{ $t('editingModeEnabled') }}</b>
					
					<div
						v-for="(stageMode, indexMode) in stage.stagePatchMode"
						:key="indexMode"
						class="vx-col mb-3 w-full mt-4"
					>
						<b>{{ $t('stagePatchModeNumber') }} № {{ indexMode+1 }}.</b>

						<span
							v-if="stageMode.files.length < 1"
						>
							{{ $t('filesAreNotUploaded') }}
						</span>
						<div class="mt-2 mb-2" v-html="stageMode.comment"></div>
						<div 
							v-if="stageMode.files.length > 0"
							v-for="(file, indexPatchMode) in stageMode.files" :key="indexPatchMode"
						>
							<a
								target="_blank"
								:href="file.url"
								:title="file.name"
							>
								{{ $t('fileNumbering') }} {{ indexPatchMode+1 }}
							</a>
							<br>
						</div>

						<div v-if="stageMode.status == 'new' && stageMode.files.length > 0" class="vx-row mt-2">
							<div class="vx-col">
								<vs-button
									@click="patchModePopupActive = true"
									class="stage__control"
									color="warning"
								>{{ $t('modify') }}</vs-button>
							</div>
							<div class="vx-col">
								<vs-button
									@click="doneAfterPatchModePopupActive = true"
									class="stage__control"
									color="success"
								>{{ $t('acceptJob') }}</vs-button>
							</div>
						</div>
						<hr class="mt-4 mb-2 w-full">
					</div>

				</div>
			</div>
		</div>
		<div class="mt-3 flex-wrap">
			<div class="stage-info vx-row">
				<div class="vx-col mb-4">
					<span>
						{{ $t('recommendedPaymentSum') }}:
						<b>{{ recommendedPrice }} €</b>
					</span><br/>
					<span class="d-flex align-center">{{ $t('totalPaymentSum') }}: <b class="ml-1">{{ totalSum }} €</b>
						<span class="ml-3" v-if="recommendedPrice > totalSum">
							<vs-tooltip :text="$t('lowerThanRecommendedSum')">
								 <vs-input-number style="display: none"/>
								<svg width="24" height="21" x="0" y="0" class="stencil--easier-to-select" style="opacity: 1;"><defs></defs><rect x="0" y="0" width="24" height="21" fill="transparent" class="stencil__selection-helper"></rect><path d="M12 0C12 0 0 21.000000000000004 0 21.000000000000004 0 21.000000000000004 24 21.000000000000004 24 21.000000000000004M12 4.421052631578947C12 4.421052631578947 20.214545454545455 18.78947368421053 20.214545454545455 18.78947368421053 20.214545454545455 18.78947368421053 3.785454545454545 18.78947368421053 3.785454545454545 18.78947368421053M10.90909090909091 8.842105263157896C10.90909090909091 8.842105263157896 10.90909090909091 13.263157894736842 10.90909090909091 13.263157894736842 10.90909090909091 13.263157894736842 13.09090909090909 13.263157894736842 13.09090909090909 13.263157894736842 13.09090909090909 13.263157894736842 13.09090909090909 8.842105263157896 13.09090909090909 8.842105263157896M10.90909090909091 15.473684210526317C10.90909090909091 15.473684210526317 10.90909090909091 17.68421052631579 10.90909090909091 17.68421052631579 10.90909090909091 17.68421052631579 13.09090909090909 17.68421052631579 13.09090909090909 17.68421052631579 13.09090909090909 17.68421052631579 13.09090909090909 15.473684210526317 13.09090909090909 15.473684210526317" stroke-width="0" stroke="none" stroke-dasharray="none" fill="rgb(234, 84, 85)" fill-rule="evenOdd"></path></svg>
							</vs-tooltip>
						</span>
					</span>
				</div>
				<div 
					v-if="$store.state.auth.role !== 'partner'"
					class="vx-col"
				>
					<vs-button 
					:disabled="model.managerNext > 0"
					v-if="!isReadOnly || boolCanEditWithoutNotice" @click="addStage">{{ $t('addStage') }}</vs-button>
				</div>
			</div>

			<template v-if="!isReadOnly && !boolCanEditWithoutNotice && $store.state.auth.role !== 'partner'">
				<vs-button
					:disabled="model.managerNext > 0"
					v-if="!isSendForApprovalClicked"
					@click="sendOrderApproval"
					class="mr-3 mt-4"
				>{{ $t('sendForApproval') }}</vs-button>

				<vs-button
					:disabled="model.managerNext > 0"
					v-else
					disabled
					class="mr-3 mt-4"
				>{{ $t('sendForApproval') }}</vs-button>
			</template>

			<template v-if="status === 'waiting_payment' && $store.state.auth.role !== 'partner'">
				<vs-button
					:disabled="model.managerNext > 0"
					v-if="!isEditClicked"
					@click="enableEditing"
					class="mr-2 mt-4"
				>{{ $t('edit') }}</vs-button>

				<vs-button
					:disabled="model.managerNext > 0"
					v-else
					disabled
					class="mr-2 mt-4"
				>{{ $t('edit') }}</vs-button>
			</template>

			<template v-if="isCanEditStages && !boolCanEditWithoutNotice && $store.state.auth.role !== 'partner'">
				<vs-button
					:disabled="model.managerNext > 0"
					@click="enableEditingWithoutNotice"
					class="mr-2 mt-4"
				>{{ $t('editWithoutNotice') }}</vs-button>
			</template>

			<template v-if="boolCanEditWithoutNotice">
				<vs-button
					:disabled="model.managerNext > 0"
					@click="disableEditingWithoutNotice"
					class="mr-2 mt-4"
				>{{ $t('editOffWithoutNotice') }}</vs-button>
			</template>

			<template v-if="!isReadOnly && !boolCanEditWithoutNotice && $store.state.auth.role !== 'partner'">
				<vs-button
					:disabled="model.managerNext > 0"
					v-if="!isApproveClicked"
					@click="confirmOrder"
					color="success"
					class="mt-4"
				>{{ $t('approve') }}</vs-button>

				<vs-button	
					:disabled="model.managerNext > 0"
					v-else
					disabled
					color="success"
					class="mt-4"
				>{{ $t('approve') }}</vs-button>
			</template>
		</div>
	</vx-card>


</template>

<script>
import SetStageFailedPopup from "@/components/dialogs/SetStageFailedPopup";
import SetStageDonePopup from "@/components/dialogs/SetStageDonePopup";
import SetAddNewAmountAuthorPopup from "@/components/dialogs/SetAddNewAmountAuthorPopup";
import SetStageDoneAfterPatchModePopup from "@/components/dialogs/SetStageDoneAfterPatchModePopup";
import SetStagePatchModePopup from "@/components/dialogs/SetStagePatchModePopup";
import vSelect from "vue-select";
import moment from "moment";
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import NewPriceJMPopupActive from "@/components/dialogs/NewPriceJMPopupActive";
import NewPriceSPopupActive from "@/components/dialogs/NewPriceSPopupActive";
import ConfirmPaymentModal from "@/components/dialogs/ConfirmPaymentModal";

export default {
	name: "CardStages",
	mixins: [databaseManager, notifier],
	props: {
		orderId: { default: -1, 	type: Number },
		stages:  { default: [] },
		status:  { default: "new", 	type: String },
		works:   { default: [] },
		author:  { default: null },
		model:  { default: null }
	},
	components: {
		SetStageFailedPopup,
		SetStageDonePopup,
		SetAddNewAmountAuthorPopup,
		SetStageDoneAfterPatchModePopup,
		SetStagePatchModePopup,
		vSelect,
		NewPriceJMPopupActive,
		NewPriceSPopupActive,
		ConfirmPaymentModal,
	},
	data() {
		return {
			selectedStage: [],
			recommendedPrice: 0,
			orderMilestone: 0,
			failedPopupActive: false,
			donePopupActive: false,
			addNewAmountAuthorPopupActive: false,
			doneAfterPatchModePopupActive: false,
			patchModePopupActive: false,
			updateTimeout: null,
			stagesUpdatingList: new Set(),
			paymentPhotos: [],
			isNotUploadingPayment: true,
			setNewPriceJMPopupActive: false,
			setNewPriceSPopupActive: false,
			confirmPaymentModalActive: false,
			patchModeStages: [],

			isSendForApprovalClicked: false,
			isApproveClicked: false,
			isEditClicked: false,

			boolCanEditWithoutNotice: false,
		}
	},
	watch: {
		orderId() {
			this.updateRecommendedPrice();
		}
	},
	computed: {
		priceForAuthor() {
			if(!this.author) return 0

			return this.author.quality_level === 3
				? this.currentStage.price_senior
				: this.currentStage.price_junior_middle
		},
		minDate() {
			return new Date();
		},
		isReadOnly() {
			if(this.status === 'new'
				|| this.status === 'client_not_answer'
				|| this.status === 'processing') return false;

			return true;
		},
		isCanEditStages() {
			if(this.boolCanEditWithoutNotice) {
				return false;
			}

			if(this.status === 'waiting_author'
				|| this.status === 'waiting_approve'
				|| this.status === 'in_progress') return true;

			return false;
		},
		totalSum(){
			return this.stages.reduce((acc,el)=>{
				return acc + Number(el.price_client);
			},0)
		},
		currentStage() {
			const current = this.stages.find(item => item.status !== 'completed');
			return current !== -1 ? current : null;
		},
		// async getListPachMode(stageId) {
		// 	returnthis.patchModeStages = await this.dbViewPatchModeStages(stageId);
			
		// },
	},
	methods: {
		currentStageFSR(id) {
			const current = this.stages.find(item => item.id === id);
			return current !== -1 ? current : null;
		},
		async updateRecommendedPrice() {
			if(this.orderId === -1) return;

			const res = await this.dbGetRecommendedPrice(this.orderId);
			this.recommendedPrice = res.price;
		},
		canManageStage(stage) {
			if(!this.currentStage) return false;

			if(this.currentStage.status === "in_progress"
				&& stage.id === this.currentStage.id)
				return true;

			return false;
		},
		canShowStageStatus(stage) {
			return !this.canManageStage(stage)
				&& (stage.status === "completed" || stage.status === "failed");
		},
		canShowUpload(stage) {
			if(!this.currentStage) return false;

			return this.isReadOnly
				&& this.isNotUploadingPayment
				&& this.currentStage.id === stage.id
				&& (this.status === "waiting_payment"
				|| (this.currentStage === stage && stage.status === 'new' && this.status !== 'waiting_author'));
		},
		sortStages() {
			this.stages.sort((a, b) => {
				const aDate = moment(a.due_date).format("YYYY-MM-DD");
				const bDate = moment(b.due_date).format("YYYY-MM-DD");

				if(aDate > bDate) return 1;
				if(aDate < bDate) return -1;
				return 0;
			});
		},
		updateStagesTypes(type) {
			if(type === null) {
				this.stages = [];
				return;
			}

			this.stages.forEach(item => {
				const work = this.works.find(work => work.id === item.work_type_id);

				if(work) return;

				item.work_type_id = type;
				this.changeStage(item);
			});
		},
		async addStage() {
			try{
				if(this.works.length === 0) {
					this.notifyError(this.$t('firstlyAddWorkTypeToOrder'));
					return;
				}

				const dueDate = this.stages.length
					? moment(this.stages[this.stages.length - 1].due_date)
						.format("YYYY-MM-DD")
					: moment(new Date()).format("YYYY-MM-DD");

				const dueTimeAuthor = this.stages.length
					? moment(this.stages[this.stages.length - 1].dueTimeAuthor)
						.format("YYYY-MM-DD HH:mm")
					: moment(new Date()).format("YYYY-MM-DD HH:mm");

				const data = {
					price_client: 0,
					price_junior_middle: 0,
					price_senior: 0,
					pages_number: 0,
					due_date: dueDate,
					dueTimeAuthor: dueTimeAuthor,
					work_type_id: this.works[0].id,
				};

				const stage = await this.dbCreateStage(this.orderId, data);
				this.stages.push(stage);
				this.sortStages();

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async saveStageChanges(stage) {
			try {
				stage.invoices = stage.invoices || [];

				const data = {
					price_client: stage.price_client,
					price_junior_middle: stage.price_junior_middle,
					price_senior: stage.price_senior,
					pages_number: stage.pages_number,
					due_date: moment(stage.due_date).format("YYYY-MM-DD"),
					dueTimeAuthor: moment(stage.dueTimeAuthor).format("YYYY-MM-DD HH:mm"),
					work_type_id: stage.work_type_id,
					files: stage.files ? stage.files.map(item => item.url) : [],
					invoices: stage.invoices ? stage.invoices.map(item => item.url) : [],
				};

				const updated = await this.dbUpdateStage(stage.id, data);
				this.currentStage.invoices = updated.invoices;
				// this.notifySuccess(this.$t('changedSuccessfully'));

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async changeStage(stage, isImmediate = false){
			if(stage.work_type_id === '') {
				return;
			}

			this.stagesUpdatingList.add(stage);

			if(!isImmediate) {
				if(this.updateTimeout !== null) {
					clearTimeout(this.updateTimeout);
				}

				this.updateTimeout = setTimeout(() => {
					this.changeStage(stage, true);
					this.updateTimeout = null;
				}, 1000);

				return;
			}

			for(let s of this.stagesUpdatingList.values()) {
				await this.saveStageChanges(s);
			}

			this.$emit('updateStages');
			this.stagesUpdatingList.clear();

			this.sortStages();
			await this.updateRecommendedPrice();
		},
		async removeStage(id) {
			try{
				if(id !== undefined) {
					await this.dbRemoveStage(id);
				}
				const index = this.stages.findIndex(item => item.id === id);
				this.stages.splice(index,1);

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		addPaymentPhotos(path, files) {
			this.paymentPhotos.push(files[files.length - 1]);
		},
		deletePaymentPhoto(file) {
			const index = this.paymentPhotos.findIndex(item => item === file);
			if(index !== -1) {
				this.paymentPhotos.splice(index, 1);
			}
		},
		async uploadPayment() {
			const files = this.paymentPhotos;
			if(files.length === 0) return;

			try {
				const urls = await this.dbUploadMany(files);

				const stage = this.currentStage;
				stage.invoices = stage.invoices || [];
				urls.forEach(item => stage.invoices.push(item));

				await this.changeStage(stage);

				this.paymentPhotos = [];
			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async confirmStagePayment(id) {
			try{
				this.isNotUploadingPayment = false;
				await this.uploadPayment();
				await this.dbConfirmStagePayout(id);
				this.notifySuccess(this.$t('youdownloadChecksSuccessfully'));
				this.$emit("updateModel");

			}catch (e) {
				this.notifyError(e.message);
			}

			this.isNotUploadingPayment = true;
		},
		async confirmStagePaymentInBank(stage) {
			try{
				await this.dbConfirmStagePayoutInBank(stage.id);
				this.notifySuccess(this.$t('youConfirmedPaymentSuccessfully'));
				this.$emit("updateModel");

				stage.confirmPayment = 1;
			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async sendOrderApproval() {
			this.isSendForApprovalClicked = true;

			try{
				await this.dbSendOrderApproval(this.orderId);
				this.notifySuccess(this.$t('dataWasSentToClientForApproval'));
				this.$emit("updateModel");

			} catch (e) {
				this.notifyError(e.message);
			}

			this.isSendForApprovalClicked = false;
		},
		confirmOrder() {
			this.isApproveClicked = true;

			const callback = () => this.isApproveClicked = false;
			this.$emit('confirmOrder', callback);
		},
		async setAddNewAmountAuthor() {
			this.$emit("updateModel");
			this.$emit("updateStages");
		},
		async setStageDone() {
			try{
				await this.dbSetStageDone(this.currentStage.id);
				this.notifySuccess(`${this.$t('youMarkedStageAs')} "${this.$t('completed')}"`);
				this.$emit("updateModel");
				this.$emit("updateStages");

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async setStageDoneAfterPatchMode() {
			try{
				await this.dbStageDoneAfterPatchMode(this.currentStage.id);
				this.notifySuccess(`${this.$t('youMarkedStageAs')} "${this.$t('completed')}"`);
				this.$emit("updateModel");
				this.$emit("updateStages");

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async setStagePatchMode(newComment) {
			try{
				await this.dbSetStagePatchMode(this.currentStage.id, newComment);
				this.notifySuccess(`${this.$t('changeStatusOrderToPatchModeStage')}`);
				this.$emit("updateModel");
				this.$emit("updateStages");
			}catch (e) {
				this.notifyError(e.message);
			}
		},
		async setStageFailed(reason) {
			try{
				await this.dbSetStageFailed(this.currentStage.id, reason);
				this.notifyDanger(`${this.$t('youMarkedStageAs')} "${this.$t('failed')}"`);
				this.$emit("updateModel");
				this.$emit("updateStages");

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		enableEditingWithoutNotice() {
			this.boolCanEditWithoutNotice = true;
		},
		disableEditingWithoutNotice() {
			this.boolCanEditWithoutNotice = false;
		},
		async enableEditing() {
			this.isEditClicked = true;

			try {
				await this.dbBackOrderToProcess(this.orderId);
				this.notifySuccess(`${this.$t('stageWasMovedToStatus')} "${this.$t('processing')}"`);
				this.$emit("updateModel");
				this.$emit("updateStages");

			} catch(e) {
				this.notifyError(e.message);
			}

			this.isEditClicked = false;
		},
		async viewOrder() {
			const id = this.$route.params.id;
			return await this.dbViewOrder(id);
		},
	},
	async created() {

	},
	mounted() {
		this.updateRecommendedPrice();
	}
}
</script>

<style lang="scss">
.fsrBtnPriseForAuthor {
	width: 40px;
	padding: 0.4rem 1.25rem !important;
}
.frsNotConfirmPayment {
	-moz-box-shadow:0 0 12px 8px #ff2600;
	-webkit-box-shadow:0 0 12px 8px #ff2600;
	box-shadow:0 0 12px 8px #ff2600;
}
.ticket-payment-info {
	.stage {
		border-bottom: 1px solid #e4e4e4;
		padding: 15px 0;

		&__control {
			padding: 7px 10px !important;
		}

		.head {
			display: flex;
			justify-content: space-between;
			flex-wrap: wrap;
			align-items: center;
		}

		&__title {
			font-size: 18px;
		}

		&-list {
			.vs-input {
				width: 100%;
			}

			&__item {
				display: flex;
				align-items: flex-end;
				margin-top: 8px;

				.vs-input--label {
					display: flex;
				}
			}
		}

		&__invoice {
			display: flex;
			justify-content: center;
			align-items: center;
			background-color: #e3e3e3;
			width: 200px;
			height: 200px;
			border-radius: 8px;
			margin-top: 20px;

			img {
				max-width: 100%;
				max-height: 100%;
			}
		}

		&-info {
			display: flex;
			justify-content: space-between;
			width: 100%;
		}
	}
}
</style>
